define('modules/editor/views/editors/video_amp',['require','exports','module','common/views/modal_view','env','ldsh!../../templates/editors/video_amp'],function (require, exports, module) {
  "use strict";
  var BaseView = require("common/views/modal_view"),
    config = require("env");

  module.exports = BaseView.extend({
    template: require("ldsh!../../templates/editors/video_amp"),

    events: {
      "click .js-save": "saveVideoURL"
    },

    initialize: function (options) {
      this.videoURL = (options.content || '').trim();
    },

    helpers: function () {
      return {
        videoURL: this.videoURL,
        assetsHost: config.assetsHost

      };
    },

    saveVideoURL: function (e) {
      e.preventDefault();

      var videoURL = document.getElementById("videoURL").value;
      this.trigger("modal:save", videoURL);
    }
  });
});

